import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "features section",
  id: "features"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "section__title--primary" }, "Features", -1)
const _hoisted_3 = { class: "features__container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Data Isolation ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Player data belong to ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("em", null, "you", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". Data are not shared between users, or anyone. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Soft Unlinking ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Players can unlink accounts without affecting your data. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Smart Player Merging ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Players are merged intelligently for insight into account ownership. ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Multiple Games Supported ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Multiple games are supported out of the box, including ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "rust" }, "Rust", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "gmod" }, "Garry's Mod", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Fast ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Designed around speed, rewards are provisioned on a near instant basis. ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Fully Managed ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Get your own website in no time! Don't bother with web hosting, certificates, or the like. ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Discord Roles ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Reward linked players with Discord roles in your guild. ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Discord Nitro Rewards ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Unlock Discord features by rewarding players for boosting your guild. ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Steam Group Rewards ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Grow your Steam group with rewards for membership. ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Extensible ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" We expose a ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" well-documented API")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" to integrate Steamcord with any Steam game. ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Easy Setup ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Our ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" comprehensive documentation")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" will guide you every step of the way. ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Fast Support ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Need help? Chat with a team member in our ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Discord guild")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Organization Members ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Invite members to your Steamcord organization with varying permissions. ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Vanity Domains ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Use your own domain to access your linking site. ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Custom CSS and HTML ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Customize your linking site's CSS and meta tags for total control. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feature = _resolveComponent("feature")!
  const _component_external_anchor = _resolveComponent("external-anchor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_feature, { icon: ['fas', 'database'] }, {
        title: _withCtx(() => [
          _hoisted_4
        ]),
        description: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'unlink'] }, {
        title: _withCtx(() => [
          _hoisted_8
        ]),
        description: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'code-merge'] }, {
        title: _withCtx(() => [
          _hoisted_10
        ]),
        description: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'box-open'] }, {
        title: _withCtx(() => [
          _hoisted_12
        ]),
        description: _withCtx(() => [
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['fas', 'bolt'] }, {
        title: _withCtx(() => [
          _hoisted_18
        ]),
        description: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['fas', 'server'] }, {
        title: _withCtx(() => [
          _hoisted_20
        ]),
        description: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'tag'] }, {
        title: _withCtx(() => [
          _hoisted_22
        ]),
        description: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['fab', 'discord'] }, {
        title: _withCtx(() => [
          _hoisted_24
        ]),
        description: _withCtx(() => [
          _hoisted_25
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['fab', 'steam'] }, {
        title: _withCtx(() => [
          _hoisted_26
        ]),
        description: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'code'] }, {
        title: _withCtx(() => [
          _hoisted_28
        ]),
        description: _withCtx(() => [
          _hoisted_29,
          _createVNode(_component_external_anchor, {
            class: "anchor--primary",
            href: "https://docs.steamcord.io/api-reference",
            "show-icon": false
          }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          }),
          _hoisted_31
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'book'] }, {
        title: _withCtx(() => [
          _hoisted_32
        ]),
        description: _withCtx(() => [
          _hoisted_33,
          _createVNode(_component_external_anchor, {
            class: "anchor--primary",
            href: "https://docs.steamcord.io",
            "show-icon": false
          }, {
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          }),
          _hoisted_35
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['far', 'life-ring'] }, {
        title: _withCtx(() => [
          _hoisted_36
        ]),
        description: _withCtx(() => [
          _hoisted_37,
          _createVNode(_component_external_anchor, {
            class: "anchor--primary",
            href: "https://discord.gg/AT5WVY4fJR",
            "show-icon": false
          }, {
            default: _withCtx(() => [
              _hoisted_38
            ]),
            _: 1
          }),
          _hoisted_39
        ]),
        _: 1
      }),
      _createVNode(_component_feature, { icon: ['fas', 'user-astronaut'] }, {
        title: _withCtx(() => [
          _hoisted_40
        ]),
        description: _withCtx(() => [
          _hoisted_41
        ]),
        _: 1
      }),
      _createVNode(_component_feature, {
        icon: ['fas', 'globe-americas'],
        pro: ""
      }, {
        title: _withCtx(() => [
          _hoisted_42
        ]),
        description: _withCtx(() => [
          _hoisted_43
        ]),
        _: 1
      }),
      _createVNode(_component_feature, {
        icon: ['fab', 'css3-alt'],
        pro: ""
      }, {
        title: _withCtx(() => [
          _hoisted_44
        ]),
        description: _withCtx(() => [
          _hoisted_45
        ]),
        _: 1
      })
    ])
  ]))
}